export default __webpack_public_path__ + "static/media/2.4c0a9cb7.jpg";